import React from 'react';
import {Glyphicon} from 'react-bootstrap'; 

export default class MainBtn extends React.Component {
  render(){
    return(
      <div className="main-btn" onClick={this.props.onClick}>
        <Glyphicon glyph={this.props.glyphicon} />
      </div>
    );
  }
}
